module.exports = {"dropDownPlaceholder":"Ohne Adobe ID anmelden"}


//////////////////
// WEBPACK FOOTER
// ./src/components/SolutionsDropdown/__localization__/SolutionsDropdown/de_de.json
// module id = 926
// module chunks = 0